import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/mall/goods/refresh.svg';
import _imports_1 from '@/assets/img/mall/goods/close.svg';
const _withScopeId = n => (_pushScopeId("data-v-6bfe93f5"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "goodsListWrapper" };
const _hoisted_2 = { class: "listHeader" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "left" }, null, -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "title" }, "商品列表", -1));
const _hoisted_5 = { class: "btns" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    alt: ""
}, null, -1));
const _hoisted_11 = [
    _hoisted_10
];
const _hoisted_12 = { class: "listBox" };
import { onUnmounted, ref, getCurrentInstance } from 'vue';
import { getLiveGoods } from '@/api/live.ts';
import { getUserId, getUrlParam, closeLiveCartList } from '@/widget/index.ts';
import GoodList from './components/goodList.vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { proxy: { $showLoading, $hideLoading } } = getCurrentInstance();
        const refreshFn = () => {
            getList();
        };
        const closeFn = () => {
            closeLiveCartList();
        };
        const list = ref([]);
        let userId = getUserId();
        let liveId = getUrlParam('liveId');
        const getList = () => {
            $showLoading();
            getLiveGoods(userId, liveId)
                .then((res) => {
                if (res.code == 200) {
                    list.value = res.data.list;
                }
                $hideLoading();
            })
                .catch(() => {
                $hideLoading();
            });
        };
        getList();
        // 获取 websocket 消息
        window.getWSjson = (json) => {
            if (json) {
                let data = JSON.parse(json);
                // CART_ALERT_HIDE  CART_ALERT_SHOW
                if (/^(CART_PRODUCT_HIDE|CART_PRODUCT_HIDE)$/.test(data.messageType)) {
                    // 上下架
                    getList();
                }
            }
        };
        onUnmounted(() => {
            delete window.getWSjson;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", {
                            class: "refresh",
                            onClick: _withModifiers(refreshFn, ["stop"])
                        }, _hoisted_8, 8, _hoisted_6),
                        _createElementVNode("div", {
                            class: "close",
                            onClick: _withModifiers(closeFn, ["stop"])
                        }, _hoisted_11, 8, _hoisted_9)
                    ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _createVNode(GoodList, { list: list.value }, null, 8, ["list"])
                ])
            ]));
        };
    }
});
